import { FC } from 'react';
import { languageCodeOptions } from 'lib/languages/constants';
import Switch from 'components/shared/generic/switch/presentational/Switch';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import Select from 'components/shared/form/presentational/Select';
import Field from 'components/shared/form/presentational/Field';
import useTranslate from 'lib/languages/useTranslate';

interface SettingsProps {
    isDarkModeEnabled: boolean;
    onDarkModeToggle: (isEnabled: boolean) => void;
    selectedLanguage: string;
    onLanguageChange: (e: any, value: string) => void;
}

const Settings: FC<SettingsProps> = ({
    onDarkModeToggle,
    isDarkModeEnabled,
    selectedLanguage,
    onLanguageChange,
}) => {
    const translate = useTranslate('appSettings');

    return (
        <div className="settings-container">
            {languageCodeOptions.length > 1 && (
                <Field>
                    <SectionTitle
                        title={translate('preferredLanguage')}
                        secondary
                    />
                    <Select
                        name="languageCode"
                        onChange={onLanguageChange}
                        value={selectedLanguage}
                        options={languageCodeOptions}
                        classes="generic-input modal-select"
                        required
                    />
                </Field>
            )}
            <div className="setting">
                <SectionTitle title={translate('darkMode')} secondary />
                <Switch
                    name="darkMode"
                    value={isDarkModeEnabled}
                    onChange={() => onDarkModeToggle(!isDarkModeEnabled)}
                    tracking
                    trackingLabel="DARK_MODE_SWITCH_CLICK"
                />
            </div>
        </div>
    );
};

export default Settings;
